/**
 * ProSports shared wishlist (app ↔ website).
 * Source of truth: customer metafield prosports.wishlist (JSON).
 *
 * Expects window.ProSportsWishlistConfig from Liquid snippet.
 */
(function () {
  'use strict';

  var cfg =
    window.ProSportsWishlistConfig || window.ProsportsWishlistConfig || {};
  var API_BASE = (
    cfg.apiBase ||
    'https://api.prosportskw.com/kangaroo/website'
  ).replace(/\/+$/, '');
  var STORAGE_KEY = 'prosports_wishlist_guest_v1';
  var state = {
    items: [],
    loading: false,
    synced: false,
  };

  function productGid(id) {
    var raw = String(id || '').trim();
    if (!raw) return '';
    if (raw.indexOf('gid://shopify/Product/') === 0) return raw;
    var digits = raw.replace(/\D/g, '');
    return digits ? 'gid://shopify/Product/' + digits : raw;
  }

  function variantGid(id) {
    var raw = String(id || '').trim();
    if (!raw) return '';
    if (raw.indexOf('gid://shopify/ProductVariant/') === 0) return raw;
    var digits = raw.replace(/\D/g, '');
    return digits ? 'gid://shopify/ProductVariant/' + digits : raw;
  }

  function stripHtmlText(value) {
    return String(value || '')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/p>/gi, ' ')
      .replace(/<[^>]+>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isLoggedIn() {
    return Boolean(cfg.customerEmail && cfg.customerId);
  }

  function readGuest() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeGuest(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items || []));
    } catch (e) {
      // ignore quota
    }
  }

  function post(path, body) {
    return fetch(API_BASE + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body || {}),
      credentials: 'omit',
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error(data.message || data.error || 'Wishlist request failed.');
            err.status = res.status;
            throw err;
          }
          return data;
        });
    });
  }

  function itemFromConfig(input) {
    var productId = productGid(input.productId || input.product_id || input.id);
    var variantId = variantGid(input.variantId || input.variant_id || input.variant);
    if (!productId || !variantId) return null;
    var currency = input.currencyCode || input.currency || cfg.currencyCode || 'KWD';
    var price = stripHtmlText(input.price || '');
    var compareAtPrice = stripHtmlText(
      input.compareAtPrice || input.compare_at_price || '',
    );
    if (price && !/\s/.test(String(price)) && /^\d/.test(String(price))) {
      price = currency + ' ' + price;
    }
    var discount = input.discountPercent || input.discount_percent;
    if (discount != null && discount !== '') {
      discount = Number(discount);
      if (isNaN(discount) || discount <= 0) discount = undefined;
    } else {
      discount = undefined;
    }
    var available = input.available;
    if (available === 'false') available = false;
    if (available === 'true') available = true;

    return {
      productId: productId,
      variantId: variantId,
      title: stripHtmlText(input.title || input.name || '') || 'Product',
      handle: input.handle || undefined,
      imageUrl: input.imageUrl || input.image_url || input.image || '',
      price: price || currency + ' 0',
      currencyCode: currency,
      compareAtPrice: compareAtPrice || undefined,
      discountPercent: discount,
      category: input.category === 'fitness' ? 'fitness' : 'sports',
      available: available === false ? false : undefined,
    };
  }

  function idsSet(items) {
    var set = {};
    (items || []).forEach(function (item) {
      set[item.productId] = true;
      var numeric = String(item.productId).replace(/\D/g, '');
      if (numeric) set[numeric] = true;
    });
    return set;
  }

  function dispatch() {
    var detail = {
      items: state.items.slice(),
      count: state.items.length,
      ids: idsSet(state.items),
      loggedIn: isLoggedIn(),
      synced: state.synced,
    };
    window.ProSportsWishlist = Object.assign(window.ProSportsWishlist || {}, {
      items: detail.items,
      count: detail.count,
      ids: detail.ids,
      loggedIn: detail.loggedIn,
    });
    window.ProsportsWishlist = window.ProSportsWishlist;
    document.dispatchEvent(new CustomEvent('prosports:wishlist', { detail: detail }));
    document.dispatchEvent(
      new CustomEvent('prosports:wishlist:change', { detail: detail }),
    );
    updateDom(detail);
  }

  function updateDom(detail, root) {
    var scope = root || document;
    scope.querySelectorAll('[data-prosports-wishlist-count]').forEach(function (el) {
      el.textContent = String(detail.count);
      el.hidden = detail.count <= 0;
    });
    scope.querySelectorAll('[data-prosports-wishlist-toggle]').forEach(function (btn) {
      var pid = productGid(btn.getAttribute('data-product-id'));
      var numeric = pid.replace(/\D/g, '');
      var on = Boolean(detail.ids[pid] || (numeric && detail.ids[numeric]));
      btn.classList.toggle('is-wishlisted', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      btn.setAttribute('title', on ? 'Remove from wishlist' : 'Add to wishlist');
      var label = btn.querySelector('[data-prosports-wishlist-label]');
      if (label) {
        label.textContent = on
          ? (cfg.labels && cfg.labels.remove) || 'Remove'
          : (cfg.labels && cfg.labels.add) || 'Wishlist';
      }
    });
  }

  function bootstrapFromLiquid() {
    if (Array.isArray(cfg.metafieldWishlist) && cfg.metafieldWishlist.length) {
      state.items = cfg.metafieldWishlist
        .map(itemFromConfig)
        .filter(Boolean);
      state.synced = true;
      dispatch();
      return true;
    }
    return false;
  }

  function syncFromCloud() {
    if (!isLoggedIn()) {
      state.items = readGuest();
      state.synced = true;
      dispatch();
      return Promise.resolve(state.items);
    }

    state.loading = true;
    return post('/wishlist/fetch', {
      email: cfg.customerEmail,
      shopifyCustomerId: cfg.customerId,
      guestItems: readGuest(),
    })
      .then(function (data) {
        if (Array.isArray(data.items)) {
          state.items = data.items.map(itemFromConfig).filter(Boolean);
          writeGuest([]); // guest merged into cloud
          state.synced = true;
        } else {
          // unresolved — keep liquid/guest until Admin is healthy
          if (!state.items.length) state.items = readGuest();
          state.synced = false;
        }
        dispatch();
        return state.items;
      })
      .catch(function () {
        if (!state.items.length) state.items = readGuest();
        state.synced = false;
        dispatch();
        return state.items;
      })
      .finally(function () {
        state.loading = false;
      });
  }

  function toggle(rawItem) {
    var item = itemFromConfig(rawItem || {});
    if (!item) {
      return Promise.reject(new Error('Missing product/variant id.'));
    }

    if (!isLoggedIn()) {
      var guest = readGuest();
      var exists = guest.some(function (g) {
        return g.productId === item.productId;
      });
      var next = exists
        ? guest.filter(function (g) {
            return g.productId !== item.productId;
          })
        : guest.concat([item]);
      writeGuest(next);
      state.items = next;
      state.synced = true;
      dispatch();
      if (cfg.requireLoginForSave) {
        window.location.href =
          cfg.loginUrl ||
          '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
      }
      return Promise.resolve({ wishlisted: !exists, items: next });
    }

    return post('/wishlist/toggle', {
      email: cfg.customerEmail,
      shopifyCustomerId: cfg.customerId,
      item: item,
    }).then(function (data) {
      state.items = Array.isArray(data.items)
        ? data.items.map(itemFromConfig).filter(Boolean)
        : state.items;
      state.synced = true;
      dispatch();
      return data;
    });
  }

  function isWishlisted(productId) {
    var gid = productGid(productId);
    var numeric = gid.replace(/\D/g, '');
    var set = idsSet(state.items);
    return Boolean(set[gid] || (numeric && set[numeric]));
  }

  function attr(btn) {
    var keys = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < keys.length; i++) {
      var v = btn.getAttribute(keys[i]);
      if (v != null && v !== '') return v;
    }
    return null;
  }

  function onClick(event) {
    var btn = event.target.closest('[data-prosports-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (state.loading) return;

    var availableAttr = attr(btn, 'data-available');
    var payload = {
      productId: attr(btn, 'data-product-id'),
      variantId: attr(btn, 'data-variant-id'),
      handle: attr(btn, 'data-handle'),
      title: attr(btn, 'data-product-title', 'data-title'),
      imageUrl: attr(btn, 'data-product-image', 'data-image-url'),
      price: attr(btn, 'data-product-price', 'data-price'),
      currencyCode: attr(btn, 'data-currency', 'data-currency-code') || 'KWD',
      compareAtPrice: attr(btn, 'data-compare-at-price') || undefined,
      discountPercent: attr(btn, 'data-discount-percent') || undefined,
      category: attr(btn, 'data-category') || 'sports',
      available: availableAttr,
    };

    btn.disabled = true;
    toggle(payload)
      .catch(function (err) {
        console.warn('[ProSportsWishlist]', err && err.message ? err.message : err);
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  document.addEventListener('click', onClick, true);

  function getItems() {
    return state.items.slice();
  }

  function syncButtons(root) {
    updateDom(
      {
        items: state.items,
        count: state.items.length,
        ids: idsSet(state.items),
        loggedIn: isLoggedIn(),
        synced: state.synced,
      },
      root || document,
    );
  }

  window.ProSportsWishlist = {
    sync: syncFromCloud,
    toggle: toggle,
    isWishlisted: isWishlisted,
    getItems: getItems,
    getWishlist: getItems,
    syncButtons: syncButtons,
    refreshUi: dispatch,
  };
  window.ProsportsWishlist = window.ProSportsWishlist;

  bootstrapFromLiquid();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncFromCloud();
    });
  } else {
    syncFromCloud();
  }
})();
